"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storageContants_1 = require("../constants/storageContants");
var Auth_1 = require("../context/Auth");
var axios_1 = __importDefault(require("axios"));
var config_1 = __importDefault(require("config"));
var tokens = localStorage.getItem(storageContants_1.AUTHENTICATE_USER_TOKENS);
var parseTokens = JSON.parse(tokens || '{}');
var isRefreshing = false;
var failedRequestsQueue = [];
var api = axios_1.default.create({
    baseURL: config_1.default.apiUrl,
    headers: {
        'authorization-token': 'Bearer ' + parseTokens.token,
    },
});
api.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    var _a, _b;
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        if (((_b = error.response.data) === null || _b === void 0 ? void 0 : _b.code) === 'token.expired') {
            var tokens_1 = localStorage.getItem(storageContants_1.AUTHENTICATE_USER_TOKENS);
            parseTokens = JSON.parse(tokens_1 || '{}');
            var refresh_token = parseTokens.refresh_token;
            if (!refresh_token)
                return (0, Auth_1.signOut)();
            var originalConfig_1 = error.config;
            if (!isRefreshing) {
                isRefreshing = true;
                api
                    .post("/api/v1/refresh-token", {
                    refresh_token: refresh_token,
                })
                    .then(function (response) {
                    var _a = response.data, refresh_token = _a.refresh_token, token = _a.token;
                    localStorage.setItem(storageContants_1.AUTHENTICATE_USER_TOKENS, JSON.stringify({ refresh_token: refresh_token, token: token }));
                    api.defaults.headers['authorization-token'] = "Bearer ".concat(token);
                    failedRequestsQueue.forEach(function (request) { return request.onSuccess(token); });
                    failedRequestsQueue = [];
                })
                    .catch(function (err) {
                    var _a, _b;
                    if ((err === null || err === void 0 ? void 0 : err.response) &&
                        ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) &&
                        ((_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data.status) === 'error') {
                        (0, Auth_1.signOut)();
                        return;
                    }
                    failedRequestsQueue.forEach(function (request) { return request.onFailure(err); });
                    failedRequestsQueue = [];
                })
                    .finally(function () {
                    isRefreshing = false;
                });
            }
            return new Promise(function (resolve, reject) {
                failedRequestsQueue.push({
                    onSuccess: function (token) {
                        originalConfig_1.headers['authorization-token'] = "Bearer ".concat(token);
                        resolve(api(originalConfig_1));
                    },
                    onFailure: function (err) {
                        reject(err);
                    },
                });
            });
        }
        else {
            (0, Auth_1.signOut)();
        }
    }
    return Promise.reject(error);
});
exports.default = api;
